import React from 'react';
import cn from './../../lib/bem';
import { validarCaracteresEspeciales, validarNumero } from './../../lib/utils';

import './inputDocument_component.scss';
import { CE_VALUE, DNI_VALUE } from '../../domains/commons/constants';

const InputDocumentComponent = (props) => {
  const classes = cn('inputDocumentComponent');

  const onChangeInputDocument = (value) => {
    if (
      props.valueTipoDoc === DNI_VALUE &&
      (!validarNumero(value) || value.length > 8)
    )
      return;
    if (
      props.valueTipoDoc === CE_VALUE &&
      (validarCaracteresEspeciales(value) || value.length > 12)
    )
      return;
    props.onChangeMsgDoc('');
    props.onChangeNroDoc(value);
  };

  const onChangeInputTipo = (value) => {
    props.onChangeNroDoc('');
    props.onChangeMsgDoc('');
    props.onChangeTipoDoc(value);
  };

  return (
    <div className={classes()}>
      <label className={classes('inputDocumentLabel')}>
        Tipo y número de documento
      </label>
      <select
        aria-label="cboTipoDocument"
        name="selectDocument"
        className={
          props.valueMsgDoc === ''
            ? classes('inputDocumentSelect')
            : classes('inputDocumentSelect selectError')
        }
        value={props.valueTipoDoc}
        onChange={(e) => onChangeInputTipo(e.target.value)}
        required
      >
        <option value={DNI_VALUE}>DNI</option>
        <option value={CE_VALUE}>CE</option>
      </select>
      <input
        aria-label="txtNroDocumento"
        name="inputDocumento"
        className={
          props.valueMsgDoc === ''
            ? classes('inputDocumentInput')
            : classes('inputDocumentInput inputError')
        }
        value={props.valueNroDoc}
        onChange={(e) => onChangeInputDocument(e.target.value)}
        placeholder="Ingresar documento"
        autoComplete="off"
      />
      <label className={classes('inputDocumentLabelError')}>
        {props.valueMsgDoc}
      </label>
    </div>
  );
};

export default InputDocumentComponent;
